import React from "react";
import { Card, CardContent, Typography, Button, Box } from "@material-ui/core";


export default function CardapioCard({ dia, cor, onEditar, onVisualizar }) {
return (
<Card style={{
minWidth: 250,
borderRadius: 12,
boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
background: "#fff",
marginBottom: 16,
}}>
<CardContent>
<Typography variant="h6" style={{ color: cor, fontWeight: 600 }}>
{dia}
</Typography>
<Typography variant="body2" color="textSecondary">
Clique abaixo para editar ou visualizar o cardápio.
</Typography>


<Box display="flex" justifyContent="space-between" marginTop={16}>
<Button variant="contained" color="primary" onClick={onEditar}>
EDITAR
</Button>
<Button variant="outlined" onClick={onVisualizar}>
VISUALIZAR
</Button>
</Box>
</CardContent>
</Card>
);
}